export const getNotificationMessage = state => state.get('message');
export const getNotificationType = state => state.get('notificationType');
export const getNotificationShowForMS = state => state.get('showForMS');
export const getNotificationCloseImmediately = state => state.get('closeImmediately');
